import { Dispatch } from 'redux';
import { PageRequest } from '../../../api/api.types';
import { reservationApi } from '../../../api/reservation/reservation.client';
import { ReservationEditRequest, ReservationFilters } from '../../../api/reservation/reservation.types';
import {
  GET_RESERVATION, GET_RESERVATION_LIST, PATCH_RESERVATION, UPDATE_RESRVATION_FILTERS
} from '../types/reservation.types';

export const getReservationList = (filters?: ReservationFilters, pageRequest?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await reservationApi.Reservations.listAllReservations(filters, pageRequest);

  dispatch({
    type: GET_RESERVATION_LIST,
    payload: {
      page: response.data
    }
  });

  return Promise.resolve();
};

export const getReservation = (reservationNumber: string, uuid?: string, supplier?: string) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await reservationApi.Reservations.getOneReservation(reservationNumber, uuid, supplier);

    dispatch({
      type: GET_RESERVATION,
      payload: {
        selectedReservation: response.data
      }
    });

  } catch (e) {
    dispatch({
      type: GET_RESERVATION,
      payload: {
        selectedReservation: null
      }
    });
  }
};

export const updateReservationFilters = (filters?: ReservationFilters) => async (dispatch: Dispatch<any>) => {
  dispatch({
    type: UPDATE_RESRVATION_FILTERS,
    payload: {
      filters
    }
  });
};

export const patchReservation = (reservationNumber: string, request: ReservationEditRequest, uuid?: string, supplier?: string) => async (dispatch: Dispatch<any>) => {
  const response = await reservationApi.Reservations.patchReservation(reservationNumber, request, uuid, supplier);

  dispatch({
    type: PATCH_RESERVATION,
    payload: {
      selectedReservation: response.data
    }
  });

  return Promise.resolve();
};
